import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/tags', 'delete'>;
type ResponseBody = OASOutput<O, '/api/tags', 'delete'>;

type Params = {
  guid: string;
};

type Result = Params;

export const deleteTagFactory = (apiClient: ApiClient) => {
  const deleteTag = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/tags'].delete(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody, variables);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        guid: input.guid,
      },
    };
  };

  const mapResponseToResult = (_response: ResponseBody, input: Params): Result => {
    return input;
  };

  return deleteTag;
};
